import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IFiscalYear, ICreateFiscalYearRequest, IUpdateFiscalYearRequest, IUnlockFiscalYearRequest, ILockFiscalYearRequest } from '../models/fiscal-year';

@Injectable({
  providedIn: 'root'
})
export class FiscalYearService {

  constructor(private http: HttpClient) { }

  searchFiscalYears(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IFiscalYear[]>>(
      `${environment.baseUrl}/v1/FiscalYear/searchFiscalYears`,
      request
    )
  }

  createFiscalYear(request: ICreateFiscalYearRequest){
    return this.http.post<IFiscalYear>(
      `${environment.baseUrl}/v1/FiscalYear/createFiscalYear`,
      request
    )
  }

  updateFiscalYear(request: IUpdateFiscalYearRequest){
    return this.http.put<IFiscalYear>(
      `${environment.baseUrl}/v1/FiscalYear/updateFiscalYear/${request.id}`,
      request
    )
  }

  lockFiscalYear(request: ILockFiscalYearRequest){
    return this.http.put<IFiscalYear>(
      `${environment.baseUrl}/v1/FiscalYear/lockFiscalYear`,
      request
    )
  }

  unlockFiscalYear(request: IUnlockFiscalYearRequest){
    return this.http.put<IFiscalYear>(
      `${environment.baseUrl}/v1/FiscalYear/unlockFiscalYear`,
      request
    )
  }
}
